import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { styled } from "@mui/material";
import PaginationRound from "./Pagination";
import TableCard from "../TableCard";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.gray,
    color: theme.palette.common.black,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#f5f5f588",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const BasicTable = ({
  isLoading,
  columns,
  data,
  style = {},
  maxHeight = "500px",

  paginateProps = {},
  sortConfig,
  onSort,
}) => {
  const {
    page,
    totalData,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = paginateProps;

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", ...style }}>
      <div className="hidden lg:block">
        <TableContainer component={Paper}>
          <Table
            sx={{
              tableLayout: "fixed",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  const sortKey = column.sortKey || column.id;
                  const isSortable = column.sortable && onSort;

                  return (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ width: column.minWidth }}
                    >
                      {isSortable ? (
                        <button
                          type="button"
                          onClick={() => onSort(sortKey)}
                          className="inline-flex items-center gap-1 font-inherit text-inherit"
                        >
                          {column.label}
                          <span className="text-xs">
                            {sortConfig?.key === sortKey
                              ? sortConfig.direction === "asc"
                                ? "▲"
                                : "▼"
                              : "⇅"}
                          </span>
                        </button>
                      ) : (
                        column.label
                      )}
                    </StyledTableCell>
                  );
                })}
              </TableRow>
            </TableHead>
          </Table>

          <div
            className="overflow-auto"
            style={{
              display: "block",
              maxHeight: maxHeight,
            }}
          >
            <Table
              sx={{
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <TableBody className="">
                {!isLoading && data && data.length ? (
                  data.map((row, rowIndex) => (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row?.email}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];

                        return (
                          <StyledTableCell
                            className="break-words capitalize"
                            key={column.id}
                            align={column.align}
                            style={{ width: column.minWidth }}
                          >
                            {column?.renderCell
                              ? column.renderCell(row, rowIndex)
                              : value
                              ? value
                              : value === 0
                              ? value
                              : "N/A"}
                          </StyledTableCell>
                        );
                      })}
                    </StyledTableRow>
                  ))
                ) : (
                  <div className="flex justify-center items-center ">
                    {/* <CircularProgress /> */}
                  </div>
                )}
              </TableBody>
            </Table>
          </div>
        </TableContainer>
      </div>

      <div style={{ maxHeight: maxHeight }} className="lg:hidden overflow-auto">
        <TableCard columns={columns} data={data} />
      </div>

      {Object.keys(paginateProps).length > 0 ? (
        <PaginationRound
          rowsPerPageOptions={[10, 25, 100]}
          count={totalData / rowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page + 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : (
        <></>
      )}
    </Paper>
  );
};

export default BasicTable;
